<template>
  <div id="app">
    <frist></frist>
  </div>
</template>


<script>
import frist from "./views/frist";

export default {
  data() {
    return {};
  },
  components: {
    frist,
  },
  methods: {},
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
